import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value, args: string[] = []): any {
    /**
     * Recibimos en los args, la lista de keys aceptadas Y EN EL ORDEN DEL ARRAY, por lo que en el objeto final, solo vamos a usar
     * dichas keys. Esto se hace para que cuando el back cambie, no afecte la lista de keys y
     * permita hacer cambios sin que se rompa el front
     */
    let keys = [];
    Object.keys(value).forEach(key => {
      // generamos el objeto
      keys.push({key: key, value: value[key]});
    });
    // luego de generar el objeto, filtramos para quedarnos solo con las keys disponibles y finalmente ordenamos
    if (args.length) {
      keys = keys.filter(x => args.indexOf(x.key) !== -1);
      keys.sort((a, b) => {
        return args.indexOf(a.key) - args.indexOf(b.key);
      });
    }
    return keys;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/keys.ts